import { useRef, ReactNode } from "react";
import { useOutsideClick } from "@chakra-ui/react";

interface OutsideCloseWrapperProps {
  children: ReactNode;
  onClose: () => void;
}

export const OutsideCloseWrapper: React.FC<OutsideCloseWrapperProps> = ({
  children,
  onClose,
}) => {
  const ref = useRef(null);

  useOutsideClick({
    ref,
    handler: () => {
      onClose();
    },
  });

  return <div ref={ref}>{children}</div>;
};
